import React from 'react';
import { FaCloud, FaMoneyBill, FaClock, FaCogs, FaUsers, FaDesktop, FaChartLine } from 'react-icons/fa';
import './TallyAws.css';

const TallyAws = () => {
  return (
    <div className="tally-aws-wrapper">
      {/* ── Hero Banner ── */}
      <div className="tally-hero-banner">
        <img src="/images/tallyaws-cover.png" alt="TallyPrime on AWS Cover" className="hero-banner-img" />
      </div>

      <div className="aws-hero-intro">
        <div className="aws-hero-content">
          <h1>TallyPrime on AWS</h1>
          <p>
            Experience the trust of TallyPrime with the power of AWS Cloud. 
            Access your data securely, anytime, anywhere.
          </p>
        </div>
      </div>

      {/* ── Main Narrative Features ── */}
      <section className="aws-main-features">
        <FeatureRow 
          icon={<FaCloud />}
          title="Unmatched Reliability"
          text="TallyPrime on AWS combines the simplicity of Tally products with the world-class expertise of the AWS cloud platform. Our joint engineering efforts ensure your system works for you 24/7, across any device."
        />
        <FeatureRow 
          icon={<FaUsers />}
          title="One-Stop Solution"
          text="Your Tally partner leads the entire engagement—from gathering requirements to full implementation. We handle the technical complexities so you can focus on running your business."
        />
        <FeatureRow 
          icon={<FaChartLine />}
          title="Built for Growth"
          text="Whether you're a small business or a growing enterprise, TallyPrime on AWS scales with you. Add users and resources on-demand without worrying about hardware constraints."
        />
      </section>

      {/* ── Pricing Highlight ── */}
      <section className="aws-pricing-note">
        <a href="/contact">
          <div className="pricing-bubble">
            For Pricing details Contact Us
          </div>
        </a>
      </section>

      {/* ── Secondary Features Grid ── */}
      <section className="aws-secondary-grid-section">
        <div className="grid-title">
          <h2>Why Businesses Choose AWS</h2>
        </div>
        <div className="aws-grid">
          <FeatureCard 
            icon={<FaMoneyBill />}
            title="Economical"
            text="Affordable price points with unlimited usage. No hidden costs or surprise hardware maintenance fees."
          />
          <FeatureCard 
            icon={<FaClock />}
            title="24/7 Access"
            text="Enjoy unrestricted, round-the-clock access with no limits on usage time or data transmission."
          />
          <FeatureCard 
            icon={<FaCogs />}
            title="Complete Flexibility"
            text="Seamlessly upgrade or downgrade your plan as your needs change. Add or remove users with a single click."
          />
          <FeatureCard 
            icon={<FaDesktop />}
            title="Platform Agnostic"
            text="Works perfectly across Windows, Mac, and Linux via any modern Chrome browser."
          />
        </div>
      </section>
    </div>
  );
};

const FeatureRow = ({ icon, title, text }) => {
  return (
    <div className="aws-feature-row">
      <div className="aws-feature-text">
        <h2>{title}</h2>
        <p>{text}</p>
      </div>
      <div className="aws-feature-icon-large">
        <div className="icon-box-lg">
          {icon}
        </div>
      </div>
    </div>
  );
};

const FeatureCard = ({ icon, title, text }) => {
  return (
    <div className="aws-card">
      <div className="aws-card-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
};

export default TallyAws;
